import React from "react";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import PhiloTicketFullLogo from "../../assets/PhiloTicketFullLogo.png";
import {getCurrentTab, SIDE_NAV_DATA} from "./sideNavbarHelper";

import styles from "./SideNavbar.module.scss";

export default function SideNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [tab, setTab] = useState(getCurrentTab(location.pathname));
  const iconSize = "small";

  useEffect(() => {
    const currentTab = getCurrentTab(location.pathname);
    setTab(currentTab);
  }, [location.pathname]);

  const SideNavOptions = () =>
    SIDE_NAV_DATA.map((sideBar) => {
      const {
        Icon,
        link: {url, label},
      } = sideBar;
      const selected = tab.url === url;
      return (
        <div
          key={label}
          className={`${styles.optionContainer} ${
            selected && styles.optionContainerSelected
          }`}
          onClick={() => navigate(url)}
        >
          <Icon
            {...(sideBar.IconProps && {
              ...sideBar.IconProps,
              fontSize: undefined,
            })}
            className={styles.icon}
          />

          <h1 className={styles.iconText}>{label}</h1>
        </div>
      );
    });

  return (
    <div className={styles.sideNavcontainer}>
      <img src={PhiloTicketFullLogo} className={styles.logoImage} />
      <SideNavOptions />
    </div>
  );
}
